<template>
	<div class="project-switch dropdown" v-if="switchVisible">
		<button class="btn btn-current-project">{{ currentProjectName }}</button>
		<ul class="list popup">
			<template v-for="(project, key, index) in projects">
				<li v-if="key !== currentProjectName" :key="index">

					<ProjectSwitchItem :project="project" :name="key" />

				</li>
			</template>
		</ul>
	</div>
</template>

<script>

import xhrModule from '../modules/xhrModule.js'
import ProjectSwitchItem from './ProjectSwitchItem.vue'

export default {
	name: 'ProjectSwitch',
	components: {
		'ProjectSwitchItem': ProjectSwitchItem
	},

	data () {
		return {
			user: this.$store.state.user,
			projects: [],
			currentProjectName: '',
			switchVisible: false
		}
	},

	created () {
		this.fetchProjects()
	},

	methods: {
		fetchProjects () {
			var url = '/cms/api/master/projects'
			xhrModule.get(url, this.fetchProjectsComplete.bind(this))
		},

		fetchProjectsComplete (data) {
			this.projects = data.data

			// find the name of the current project and show it in the dropdown
			let cmsDomain = this.user.project.cms_domain

			for (let key in this.projects) {
				if (this.projects[key].includes(cmsDomain)) {
					this.currentProjectName = key
					this.switchVisible = true
					return
				}
			}
		}
	}
}
</script>
